const callAsyncAPI = async (domain, data, returnedValue = "") => {
  let response = await fetch(domain, data);
  let res = await response.json();

  if (response.status == 404) {
    window.alert(
      "Error: Error: Not Found 404",
      "Api Page Not Found Please Try Again Later"
    );
    return false;
  } else if (response.status == 401) {
    window.alert(
      "Error: Authentication Failed",
      "Authentication Refused Please Contact Admin And Try Again Later"
    );
    return false;
  } else if (response.status == 500) {
    window.alert(
      "Error: Internal Server Error",
      "Internal Error Occurred Please Try Again Later"
    );
    return false;
  } else if (response.status >= 200 && response.status < 300) {
    return returnedValue ? res[`${returnedValue}`] : res;
  } else if (response.status == 405 || response.status == 400) {
    window.alert(
      "Error: Request Refused",
      "Your Request Has Been Refused From Server Please Try Again Later"
    );
    return false;
  } else {
    window.alert(
      "Error: Internet Error",
      "Internet Connection Error, Please Check Your Connection And Try Again Later"
    );
    return false;
  }
};
const callApi = (domain, data, headerToken = "", methodName = "POST") => {
  var configApi = {};
  configApi["method"] = methodName;
  if (methodName != "GET") {
    configApi["body"] = JSON.stringify(data);
  } else {
    if (window.location.hostname != "localhost") {
      domain += "?";
    }
    for (const key in data) {
      domain += key + "=" + data[key] + "&";
    }
  }
  configApi["headers"] = { Accept: "application/json" };
  if (headerToken !== "")
    configApi["headers"]["Authorization"] = "bearer " + headerToken;
  // configApi['headers']['Content-Type'] = 'application/x-www-form-urlencoded';
  let resData = callAsyncAPI(domain, configApi);
  return resData;
};

export { callAsyncAPI, callApi };
